/* milkcrates1 product page: pack size + color picker over a family of Shopify products.
   Prices, stock and variant IDs come from Shopify (mc1-data JSON); photos/tints come from the approved mockups. */
(function () {
  'use strict';
  var dataEl = document.getElementById('mc1-data');
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!D.packs || !D.packs.length) return;

  var $ = function (id) { return document.getElementById(id); };
  var HEX = { black: '#2B2E33', blue: '#2C6FB0', green: '#2E7D46', red: '#CE2B2B', gray: '#8A939C', brown: '#5C3725',
    white: '#FCFCFD', yellow: '#F2C14E', orange: '#E2622A', purple: '#7B3FA0', pink: '#FF1493', limegreen: '#A6DF29', maroon: '#810000' };
  var NAMES = { limegreen: 'Lime Green', purple: 'Purple' };

  function norm(s) {
    var c = String(s || '').toLowerCase().replace(/[^a-z]/g, '');
    if (c === 'grey') c = 'gray';
    if (c === 'back') c = 'black';
    if (/^(ultraviolet|ultravilot|violet|purple)$/.test(c)) c = 'purple';
    if (/^lime(green)?$/.test(c)) c = 'limegreen';
    return c;
  }
  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function title(s) { return String(s).replace(/\b\w/g, function (m) { return m.toUpperCase(); }); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function plural(w, n) { return n === 1 ? w : (/[^aeiou]y$/.test(w) ? w.slice(0, -1) + 'ies' : w + 's'); }
  function perPieceOk(p) { return p.units > 1 && p.min <= 1 && D.titleMode !== 'pack'; }
  function qtyVal() { return parseInt($('qty').value, 10) || 0; }

  // ---- prepare packs
  D.packs.forEach(function (p) {
    p.min = Math.max(1, p.min || 1);   // singles: minimum order quantity (shipping is built into the price)
    p.ci = -1;
    p.options.forEach(function (o, i) { if (/colou?r/i.test(o)) p.ci = i; });
    p.extra = []; p.fixed = [];
    p.options.forEach(function (name, i) {
      if (i === p.ci) return;
      var vals = [];
      p.variants.forEach(function (v) { if (vals.indexOf(v.options[i]) < 0) vals.push(v.options[i]); });
      // old "custom logo" option on some pallets: the page's own Custom Logo choice replaces it, so always use the plain crates
      if (/logo/i.test(name) || vals.some(function (x) { return /custom logo/i.test(x); })) {
        var plain = vals.filter(function (x) { return !/(with|add) custom logo/i.test(x); })[0] || vals[0];
        p.fixed.push({ i: i, value: plain }); return;
      }
      if (vals.length > 1) p.extra.push({ name: name, i: i, values: vals });
    });
    p.colors = {};
    if (p.ci >= 0) p.variants.forEach(function (v) { p.colors[norm(v.options[p.ci])] = v.options[p.ci]; });
  });

  // ---- palette: approved mockup colors first (in order), then any other Shopify color; only colors sold in this family
  var cfg = (D.media && D.media.colors) || [];
  var sold = {};
  D.packs.forEach(function (p) { Object.keys(p.colors).forEach(function (k) { sold[k] = p.colors[k]; }); });
  // colors Farmplast no longer offers on this line (theme setting per family), even if Shopify still has the variant
  ((D.media && D.media.hide) || []).forEach(function (k) {
    delete sold[k];
    D.packs.forEach(function (p) { delete p.colors[k]; });
  });
  var palette = [];
  cfg.forEach(function (c) { if (sold[c.k]) palette.push(c); });
  Object.keys(sold).forEach(function (k) {
    if (!palette.some(function (c) { return c.k === k; }))
      palette.push({ k: k, name: NAMES[k] || title(sold[k]), hex: HEX[k] || '#C9CED4', img: '', filter: '', group: 'std' });
  });
  function pal(k) { for (var i = 0; i < palette.length; i++) if (palette[i].k === k) return palette[i]; return null; }

  // ---- state
  var S = { pack: 0, color: '', extra: {}, qty: 1, logo: '' };
  var isPack = false;
  D.packs.forEach(function (p, i) { if (p.h === D.current) { S.pack = i; isPack = true; } });
  if (!isPack && D.aliases) {   // duplicate Shopify listing of a pack: open on that pack
    String(D.aliases).split(';').forEach(function (a) {
      var f = a.split('|');
      if (f[0] !== D.current) return;
      D.packs.forEach(function (p, i) { if (p.label === f[1]) S.pack = i; });
    });
  }
  (function initFromVariant() {
    var p = D.packs[S.pack];
    p.variants.forEach(function (v) {
      if (v.id !== D.variant) return;
      if (p.ci >= 0) S.color = norm(v.options[p.ci]);
      p.extra.forEach(function (o) { S.extra[o.name] = v.options[o.i]; });
    });
    if ((!S.color || !pal(S.color)) && palette.length) S.color = palette[0].k;   // also covers a hidden color
    // no specific variant in the link: open on Black like the approved mockups (if this pack sells it)
    if (!/[?&]variant=/.test(location.search) && p.ci >= 0 && S.color !== 'black' && p.colors.black !== undefined) {
      var bv = null;
      p.variants.forEach(function (v) { if (norm(v.options[p.ci]) === 'black' && v.available) bv = v; });
      if (bv) S.color = 'black';
    }
  })();

  function variantOf(p, colorKey) {
    var c = colorKey === undefined ? S.color : colorKey;
    var best = null;
    p.variants.forEach(function (v) {
      if (p.ci >= 0 && norm(v.options[p.ci]) !== c) return;
      var ok = p.extra.every(function (o) { return v.options[o.i] === (S.extra[o.name] || o.values[0]); }) &&
        p.fixed.every(function (f) { return v.options[f.i] === f.value; });
      if (ok && (!best || (!best.available && v.available))) best = v;
    });
    return best;
  }
  function stdPrice(p) {   // lowest price among standard-color variants of this pack
    var min = null;
    p.variants.forEach(function (v) {
      if (p.ci >= 0) { var c = pal(norm(v.options[p.ci])); if (c && c.group === 'spec') return; }
      if (min === null || v.price < min) min = v.price;
    });
    return min;
  }
  function singlePack() { for (var i = 0; i < D.packs.length; i++) if (D.packs[i].units === 1) return D.packs[i]; return null; }

  // ---- render
  var packsEl = $('packs'), swStd = $('swStd'), swSpec = $('swSpec'), mainImg = $('mainImg');

  function renderPacks() {
    packsEl.innerHTML = D.packs.map(function (p, i) {
      var v = variantOf(p) || p.variants[0];
      var price = v ? v.price : 0;
      return '<button type="button" class="pack' + (i === S.pack ? ' active' : '') + '" data-i="' + i + '">' +
        (p.min > 1 ? '<span class="pk-min">Min. ' + p.min + '</span>' : '') +
        (p.tag ? '<span class="pk-tag">' + esc(p.tag) + '</span>' : '') +
        '<span class="pk-name">' + esc(p.label) + '</span>' +
        (p.min > 1 ? '<span class="pk-sub pk-sub-min">Order ' + p.min + ' or more</span>'
          : p.sub ? '<span class="pk-sub">' + esc(p.sub) + '</span>'
          : perPieceOk(p) && price ? '<span class="pk-sub">' + money(Math.round(price / p.units)) + ' / ' + esc(D.unit || 'piece') + '</span>' : '') +
        '<span class="pk-price">' + money(price) + '</span></button>';
    }).join('');
    $('packGroup').hidden = D.packs.length < 2 && !D.packs[0].extra.length;
    if (D.packs.length < 2) packsEl.hidden = true;
    var p = D.packs[S.pack];
    $('extraOpts').innerHTML = p.extra.map(function (o) {
      var cur = S.extra[o.name] || o.values[0];
      return '<label class="extra-opt"><span>' + esc(o.name === 'Title' ? 'Option' : o.name) + '</span><select data-o="' + esc(o.name) + '">' +
        o.values.map(function (val) { return '<option' + (val === cur ? ' selected' : '') + '>' + esc(val) + '</option>'; }).join('') +
        '</select></label>';
    }).join('');
  }

  function swatchHtml(c, p) {
    var v = p.ci >= 0 && p.colors[c.k] !== undefined ? variantOf(p, c.k) : null;
    var off = !v || !v.available;
    return '<button type="button" class="swatch' + (c.k === S.color ? ' active' : '') + (off ? ' off' : '') + '" data-c="' + c.k + '" style="background:' + c.hex + '"' +
      ' title="' + esc(c.name) + (off ? ' (not available in this pack size)' : '') + '" aria-label="' + esc(c.name) + '"></button>';
  }
  function renderColors() {
    var p = D.packs[S.pack];
    var grp = $('colorGroup');
    // no colors at all, or a one-color line on a pack without a color option: nothing to show
    if (!palette.length || (palette.length === 1 && p.ci < 0)) { grp.hidden = true; return; }
    grp.hidden = false;
    var std = palette.filter(function (c) { return c.group !== 'spec'; });
    var spec = palette.filter(function (c) { return c.group === 'spec'; });
    swStd.innerHTML = std.map(function (c) { return swatchHtml(c, p); }).join('');
    swSpec.innerHTML = spec.map(function (c) { return swatchHtml(c, p); }).join('');
    $('stdLbl').hidden = !std.length || !spec.length;
    $('specLbl').hidden = swSpec.hidden = !spec.length;
    var c = pal(S.color);
    $('colorName').textContent = c ? c.name : '';
    var note = $('colorNote');
    if (p.ci < 0) {
      note.hidden = false;
      note.textContent = 'Colors can’t be chosen online for the ' + p.label + '. Add your colors in the order notes on the cart page, or call us.';
      [].forEach.call(grp.querySelectorAll('.swatch'), function (s) { s.classList.add('off'); });
    } else if (S.note) {
      note.hidden = false; note.textContent = S.note;
    } else { note.hidden = true; }
  }

  function setImage(src, filter) {
    if (!src) return;
    if (mainImg.getAttribute('src') !== src) mainImg.src = src;
    mainImg.style.filter = filter || 'none';
  }
  function renderImage() {
    var p = D.packs[S.pack];
    var packImg = D.media && D.media.packImgs && D.media.packImgs[p.i];
    var c = pal(S.color);
    // extra angles (from milkcratesdirect.com): the "front" one is always the color's main photo, "byc" ones
    // swap to the chosen color, "only" ones belong to one color and "packs" ones to some pack sizes;
    // the others are hidden. A photo being looked at stays on screen while it's still shown.
    var view = null;
    [].forEach.call($('thumbs').querySelectorAll('.t'), function (t, i) {
      var d = t.dataset, u = d.img, f = d.filter;
      if (d.front) { u = (c && c.img) || d.img0; f = c && c.img ? c.filter || '' : ''; }
      else if (d.byc) { u = c && JSON.parse(d.byc)[c.k]; f = ''; }
      t.hidden = !u || (!!d.only && !(c && d.only === c.k)) || (!!d.packs && d.packs.split('|').indexOf(p.label) < 0);
      if (!t.hidden && (d.front || d.byc)) { d.img = u; d.filter = f; t.querySelector('img').src = u; t.querySelector('img').style.filter = f || 'none'; }
      if (i === S.view && !t.hidden) view = t;
    });
    if (packImg && !view) setImage(packImg, '');
    else if (view) setImage(view.dataset.img, view.dataset.filter);   // keep the angle that was being looked at
    else if (c && c.img && p.ci >= 0) setImage(c.img, c.filter);
    else if (D.media && D.media.main && p.ci >= 0) setImage(D.media.main, '');
    else if (p.img) setImage(p.img, '');
    if (!view && !packImg && p.ci >= 0) view = $('thumbs').querySelector('.t[data-front]');
    [].forEach.call($('thumbs').querySelectorAll('.t'), function (t) {
      t.classList.toggle('active', (t === view && !packImg) || (t.dataset.c && t.dataset.c === S.color && !packImg) || (t.dataset.pack && t.dataset.pack === p.label));
    });
    renderDots();
  }
  // phones: the thumbnail strip is replaced by dots under the photo, and the photo can be swiped
  function renderDots() {
    var dots = $('thumbDots'); if (!dots) return;
    var ts = $('thumbs').querySelectorAll('.t:not([hidden])'), html = '';
    for (var i = 0; i < ts.length; i++) html += '<button type="button" class="dot' + (ts[i].classList.contains('active') ? ' active' : '') + '" data-i="' + i + '" aria-label="Photo ' + (i + 1) + ' of ' + ts.length + '"></button>';
    dots.innerHTML = html;
    dots.hidden = ts.length < 2;
  }
  function renderThumbs() {
    var th = (D.media && D.media.thumbs) || [];
    if (!th.length) return;   // stand-alone products keep their Shopify images (rendered in Liquid)
    $('thumbs').innerHTML = th.filter(function (t) { return !t.c || sold[t.c]; }).map(function (t) {
      return '<button type="button" class="t" data-c="' + esc(t.c) + '" data-pack="' + esc(t.pack) + '" data-img="' + esc(t.img) + '" data-filter="' + esc(t.filter) + '"' +
        (t.byc ? ' data-byc="' + esc(JSON.stringify(t.byc)) + '"' : '') + (t.front ? ' data-front="1"' : '') +
        (t.front || t.byc ? ' data-img0="' + esc(t.img) + '"' : '') +
        (t.only ? ' data-only="' + esc(t.only) + '"' : '') + (t.packs ? ' data-packs="' + esc(t.packs) + '"' : '') + '>' +
        '<img src="' + esc(t.img) + '" alt="' + esc([((document.querySelector('h1') || {}).textContent || '').trim(), t.c, t.pack].filter(Boolean).join(' – ')) + '" loading="lazy" style="filter:' + esc(t.filter || 'none') + '"></button>';
    }).join('');
  }

  function render() {
    var p = D.packs[S.pack];
    var v = variantOf(p);
    renderPacks(); renderColors(); renderImage();
    var qty = Math.max(p.min, qtyVal() || 1);
    var price = v ? v.price : 0;
    $('unitPrice').textContent = money(price);
    $('perUnit').textContent = p.units > 1 && p.min <= 1 ? '/ ' + p.label.toLowerCase() : 'each';
    var pp = $('perPiece');
    pp.hidden = !(perPieceOk(p) && price);
    if (!pp.hidden) pp.textContent = money(Math.round(price / p.units)) + ' per ' + (D.unit || 'piece') + ', shipping included';
    var mn = $('minNote');
    mn.hidden = p.min <= 1;
    if (!mn.hidden) {
      var what = D.titleMode === 'pack' ? p.label : 'single ' + plural(D.unit || 'piece', 2);
      mn.innerHTML = '<b>Minimum Order: ' + p.min + ' units</b>' +
        '<button type="button" class="hs-info" aria-label="About the minimum order" aria-expanded="false" aria-controls="minTip">i</button>' +
        '<div class="hs-tip" id="minTip" role="tooltip" hidden>' + esc(what.charAt(0).toUpperCase() + what.slice(1)) + ' are sold in quantities of ' + p.min + ' or more per color' + (price ? ' (' + money(price * p.min) + ' minimum, shipping included)' : '') + '.</div>';
    }
    if ($('qtyMin')) { $('qtyMin').hidden = p.min <= 1; $('qtyMin').textContent = 'min. ' + p.min; }
    // savings vs. buying the same number of single units
    var save = $('saveTag'), one = singlePack();
    save.hidden = true;
    if (one && one !== p && p.units > 1 && v) {
      var ov = variantOf(one) || one.variants[0];
      if (ov) {
        var pct = Math.round((1 - price / (ov.price * p.units)) * 100);
        if (pct >= 1) { save.textContent = 'Save ' + pct + '%'; save.hidden = false; }
      }
    }
    // specialty color surcharge, read from the real Shopify prices
    var sn = $('specNote'), c = pal(S.color), base = stdPrice(p);
    sn.hidden = true;
    if (v && c && c.group === 'spec' && base !== null && price > base) {
      var each = (price - base) / Math.max(1, p.units);
      sn.textContent = 'Includes specialty color: +' + money(price - base) + (p.units > 1 ? ' (' + money(each) + ' per ' + (D.unit || 'piece') + ')' : '');
      sn.hidden = false;
    }
    // title, sku, stock
    if (D.titleMode === 'pack') $('pTitle').textContent = p.label + ' (25 Compartment)';
    // family part number wins: some Shopify variants carry old internal SKUs (e.g. 8576590003)
    $('pSku').textContent = D.sku ? 'Part # ' + D.sku : (v && v.sku ? 'Part # ' + v.sku : '');
    var avail = !!(v && v.available);
    $('stock').textContent = avail ? 'In Stock' : (v ? 'Sold out' : 'Unavailable');
    $('stock').classList.toggle('oos', !avail);
    var btn = $('addBtn');
    btn.disabled = !avail;
    btn.textContent = avail ? 'Add to Cart' : (v ? 'Sold out' : 'Unavailable');
    var fee = S.logo === 'new' ? (S.logoDone ? 0 : D.logo.newPrice) : S.logo === 'reorder' ? D.logo.rePrice : 0;
    $('orderTotal').textContent = money(price * qty + fee);
    // phone Add to Cart bar mirrors the total, the choice and the button state
    if ($('mSticky')) {
      $('msPrice').textContent = $('orderTotal').textContent;
      $('msSub').textContent = [qty > 1 ? qty + ' × ' + p.label : p.label, c && p.ci >= 0 ? c.name : ''].filter(Boolean).join(' · ');
      $('msAdd').disabled = btn.disabled;
      $('msAdd').textContent = btn.textContent;
    }
    // keep the address bar on the real Shopify product + variant (shareable, correct for ads/SEO)
    if (v && window.history && history.replaceState) {
      try { history.replaceState(null, '', p.url + '?variant=' + v.id); } catch (e) {}
    }
  }

  // ---- events
  packsEl.addEventListener('click', function (e) {
    var b = e.target.closest('.pack'); if (!b) return;
    S.pack = +b.dataset.i; S.note = ''; S.view = null;
    var p = D.packs[S.pack];
    $('qty').value = p.min; $('qty').min = p.min; showMsg('');
    if (p.ci >= 0) {
      var v = variantOf(p);
      if (!v || !v.available) {   // color not sold in this pack size: switch to the first one that is
        var was = pal(S.color);
        for (var i = 0; i < palette.length; i++) {
          var cand = variantOf(p, palette[i].k);
          if (cand && cand.available) {
            if (was) S.note = was.name + ' isn’t available as a ' + p.label + ', so we switched to ' + palette[i].name + '.';
            S.color = palette[i].k; break;
          }
        }
      }
    }
    render();
  });
  $('extraOpts').addEventListener('change', function (e) {
    var s = e.target.closest('select'); if (!s) return;
    S.extra[s.dataset.o] = s.value; render();
  });
  function pickColor(k) {
    var p = D.packs[S.pack];
    var v = variantOf(p, k);
    if (p.ci >= 0 && (!v || !v.available)) return false;
    S.color = k; S.note = ''; render(); return true;
  }
  [swStd, swSpec].forEach(function (el) {
    el.addEventListener('click', function (e) {
      var s = e.target.closest('.swatch'); if (!s || s.classList.contains('off')) return;
      pickColor(s.dataset.c);
    });
  });
  $('thumbs').addEventListener('click', function (e) {
    var t = e.target.closest('.t'); if (!t) return;
    if (t.dataset.pack) {
      for (var i = 0; i < D.packs.length; i++) if (D.packs[i].label === t.dataset.pack) { packsEl.querySelector('[data-i="' + i + '"]').click(); return; }
    }
    // a photo of another color switches the color; either way show the photo that was clicked
    // (several photos can share one color, e.g. the Stack & Nest angles)
    if (t.dataset.c && t.dataset.c !== S.color && !pickColor(t.dataset.c)) return;
    S.view = t.dataset.front || t.dataset.pack || t.dataset.c ? null : [].indexOf.call(this.querySelectorAll('.t'), t);
    [].forEach.call(this.querySelectorAll('.t'), function (x) { x.classList.toggle('active', x === t); });
    setImage(t.dataset.img, t.dataset.filter);
    renderDots();
  });
  function stepPhoto(dir) {
    var ts = $('thumbs').querySelectorAll('.t:not([hidden])'); if (ts.length < 2) return;
    var cur = -1;
    for (var i = 0; i < ts.length; i++) if (ts[i].classList.contains('active')) cur = i;
    ts[cur < 0 ? (dir > 0 ? 0 : ts.length - 1) : (cur + dir + ts.length) % ts.length].click();
  }
  if ($('thumbDots')) $('thumbDots').addEventListener('click', function (e) {
    var d = e.target.closest('.dot'); if (!d) return;
    var t = $('thumbs').querySelectorAll('.t:not([hidden])')[+d.dataset.i]; if (t) t.click();
  });
  (function () {
    var box = document.querySelector('.gallery .main-img'), x0 = null, y0 = 0;
    if (!box) return;
    box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) stepPhoto(dx < 0 ? 1 : -1);
    }, { passive: true });
  })();
  function curMin() { return D.packs[S.pack].min; }
  function minMsg() { var p = D.packs[S.pack]; return 'The minimum order for ' + (D.titleMode === 'pack' ? p.label : 'single ' + plural(D.unit || 'piece', 2)) + ' is ' + p.min + '.'; }
  $('qMinus').addEventListener('click', function () {
    var q = $('qty'), n = (parseInt(q.value, 10) || 1) - 1;
    if (n < curMin()) { n = curMin(); if (curMin() > 1) showMsg(minMsg()); }
    q.value = Math.max(1, n); render();
  });
  $('qPlus').addEventListener('click', function () { var q = $('qty'); q.value = Math.max(curMin(), (parseInt(q.value, 10) || 1) + 1); showMsg(''); render(); });
  $('qty').addEventListener('input', render);
  $('qty').addEventListener('change', function () {
    if (qtyVal() < curMin()) { this.value = curMin(); if (curMin() > 1) showMsg(minMsg()); }
    render();
  });

  var hsNew = $('hotstamp'), hsRe = $('hotstampRe');
  function logoPick() {
    if (this.checked) { var other = this === hsNew ? hsRe : hsNew; if (other) other.checked = false; }
    S.logo = hsNew && hsNew.checked ? 'new' : (hsRe && hsRe.checked ? 'reorder' : '');
    if ($('hsRef')) $('hsRef').hidden = S.logo !== 'reorder';
    if ($('hsArt')) $('hsArt').hidden = S.logo !== 'new';
    if ($('hsColor')) $('hsColor').hidden = !S.logo;
    if (S.logo !== 'new' && S.logoDone) artDone(false);
    showMsg('');
    render();
  }
  // phones: the custom logo options fold away behind one "Custom Logo (optional)" row
  function logoOpen(on) {
    var box = $('logoOpts'); if (!box) return;
    box.classList.toggle('open', on);
    $('loToggle').setAttribute('aria-expanded', on ? 'true' : 'false');
  }
  if ($('loToggle')) $('loToggle').addEventListener('click', function () {
    var box = $('logoOpts');
    logoOpen(!box.classList.contains('open') || !!S.logo);   // stays open while a logo option is ticked
  });
  if ($('hsColorSel')) $('hsColorSel').addEventListener('change', function () {
    $('hsColor').classList.remove('need'); if (this.value) showMsg('');
  });
  if (hsNew) hsNew.addEventListener('change', logoPick);
  if (hsRe) hsRe.addEventListener('change', logoPick);

  // ---- logo artwork, uploaded right here and attached to the logo setup line in the cart
  var MAX_ART = 20 * 1024 * 1024;
  var ART_OK = /\.(png|jpe?g|gif|pdf|ai|eps|svg)$/i;
  S.art = null;
  function fmtSize(b) { return b > 1048576 ? (b / 1048576).toFixed(1) + ' MB' : Math.max(1, Math.round(b / 1024)) + ' KB'; }
  function setArt(file) {
    var thumb = $('hsThumb');
    if (thumb && thumb.src && thumb.src.indexOf('blob:') === 0) URL.revokeObjectURL(thumb.src);
    S.art = null;
    if (file) {
      if (!ART_OK.test(file.name)) { showMsg('That file type isn’t supported. Please upload PNG, JPG, PDF, AI, EPS or SVG.'); file = null; }
      else if (file.size > MAX_ART) { showMsg('That file is ' + fmtSize(file.size) + '. Please upload a file under 20 MB, or email it to us.'); file = null; }
    }
    if (file) {
      S.art = file; showMsg('');
      $('hsFname').textContent = file.name + ' (' + fmtSize(file.size) + ')';
      if (/^image\/(png|jpe?g|gif|svg\+xml)$/.test(file.type)) { thumb.src = URL.createObjectURL(file); thumb.hidden = false; }
      else { thumb.removeAttribute('src'); thumb.hidden = true; }
      if ($('hsLater')) $('hsLater').checked = false;
    }
    if ($('hsFileOk')) $('hsFileOk').hidden = !S.art;
    if ($('hsDrop')) $('hsDrop').hidden = !!S.art;
    if (!S.art && $('hsFile')) $('hsFile').value = '';
  }
  if ($('hsFile')) {
    $('hsFile').addEventListener('change', function () { setArt(this.files && this.files[0]); });
    $('hsRemove').addEventListener('click', function () { setArt(null); });
    $('hsLater').addEventListener('change', function () { if (this.checked) setArt(null); showMsg(''); });
    var drop = $('hsDrop');
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('drag'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('drag'); }); });
    drop.addEventListener('drop', function (e) { var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]; if (f) setArt(f); });
  }

  // once the setup line is in the cart: show the artwork as attached to the order, and don't charge setup twice
  S.logoDone = false;
  function artDone(on) {
    S.logoDone = on;
    var box = $('hsDone');
    if (!box) return;
    box.hidden = !on;
    $('hsLaterRow').hidden = on;
    if (!on) { setArt(null); return; }
    $('hsDrop').hidden = true; $('hsFileOk').hidden = true;
    var dt = $('hsDoneThumb'), t = $('hsThumb');
    if (S.art) {
      $('hsDoneTitle').textContent = '✓ Artwork attached to your order';
      $('hsDoneTxt').textContent = S.art.name + ' is saved with the logo setup in your cart.';
      if (t && !t.hidden && t.src) { dt.src = t.src; dt.hidden = false; } else dt.hidden = true;
    } else {
      $('hsDoneTitle').textContent = '✓ Logo setup added to your order';
      $('hsDoneTxt').textContent = 'Email your artwork to ' + box.getAttribute('data-email') + ' after ordering.';
      dt.hidden = true;
    }
  }

  function showMsg(text) {
    var m = $('buyMsg'); m.textContent = text; m.hidden = !text;
    if (text) {   // e.g. after tapping the phone Add to Cart bar: bring the message into view
      var r = m.getBoundingClientRect();
      if (r.top < 0 || r.bottom > window.innerHeight - 80) m.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  $('addBtn').addEventListener('click', function () {
    var p = D.packs[S.pack], v = variantOf(p);
    if (!v || !v.available) return;
    var qty = Math.max(1, qtyVal() || 1);
    if (qty < p.min) { $('qty').value = p.min; render(); showMsg(minMsg()); return; }
    var c = pal(S.color);
    var what = (D.titleMode === 'pack' ? p.label : D.title + ' — ' + p.label) + (c && p.ci >= 0 ? ' — ' + c.name : '');
    var items = [{ id: v.id, quantity: qty, properties: {} }];
    var logoColor = $('hsColorSel') ? $('hsColorSel').value : '';
    if (S.logo && $('hsColorSel') && !logoColor) {   // custom logo needs a logo color (black or white)
      logoOpen(true);
      $('hsColor').classList.add('need');
      showMsg('Please select your logo color (Black or White).');
      $('hsColor').scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    var artForm = null;   // the logo setup line goes up separately as multipart, so the artwork file travels with it
    if (S.logo === 'new' && S.logoDone) {
      items[0].properties['Custom logo'] = 'New logo setup';   // setup + artwork are already in the cart
    } else if (S.logo === 'new' && D.logo.newId) {
      var later = $('hsLater') && $('hsLater').checked;
      if (!S.art && !later) {
        showMsg('Please upload your logo artwork above, or tick "I’ll email my artwork", to add the logo setup.');
        logoOpen(true);
        if ($('hsArt')) $('hsArt').scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      items[0].properties['Custom logo'] = 'New logo setup';
      artForm = new FormData();
      artForm.append('id', String(D.logo.newId));
      artForm.append('quantity', '1');
      artForm.append('properties[For]', what);
      if (logoColor) artForm.append('properties[Logo color]', logoColor);
      // a friendly "attached" line for the customer, plus the uploaded file itself (Shopify stores it and
      // keeps the link on the line item, so it shows in checkout, the order emails and the admin order)
      if (S.art) {
        artForm.append('properties[Artwork]', '✓ ' + S.art.name + ' attached');
        artForm.append('properties[Artwork file]', S.art, S.art.name);
      } else {
        artForm.append('properties[Artwork]', 'Will be emailed after ordering');
      }
    } else if (S.logo === 'reorder' && D.logo.reId) {
      items[0].properties['Custom logo'] = 'Logo reorder';
      var ref = ($('hsRefIn') && $('hsRefIn').value.trim()) || '';
      var props = { 'For': what };
      if (ref) props['Previous order / company'] = ref;
      if (logoColor) props['Logo color'] = logoColor;
      items.push({ id: D.logo.reId, quantity: 1, properties: props });
    }
    if (S.logo && logoColor) items[0].properties['Logo color'] = logoColor;
    var btn = this; btn.disabled = true; showMsg('');
    var label = btn.textContent;
    if (artForm && S.art) btn.textContent = 'Uploading artwork…';
    function post(body, json) {
      return fetch(window.mc1.routes.cartAdd + '.js', {
        method: 'POST',
        headers: json ? { 'Content-Type': 'application/json', 'Accept': 'application/json' } : { 'Accept': 'application/json' },
        body: body
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || (r.status === 413 ? 'That artwork file is too large. Please upload a smaller file or email it to us.' : 'Could not add to cart'));
          return j;
        });
      });
    }
    // 1) the logo setup line with the artwork file (if any), 2) the crates themselves
    (artForm ? post(artForm, false) : Promise.resolve(null)).then(function () {
      return post(JSON.stringify({ items: items }), true);
    }).then(function () {
      if (window.mc1.refreshCart) window.mc1.refreshCart();
      if (artForm) artDone(true);
      var note = artForm ? (S.art ? ' with your logo artwork' : ' with the logo setup') : '';
      if (window.mc1.toast) window.mc1.toast('Added to cart' + note + ' — <a href="' + window.mc1.routes.cart + '">View cart →</a>');
    }).catch(function (err) { showMsg(err.message); })
      .then(function () { btn.textContent = label; btn.disabled = false; render(); });
  });

  // ---- go
  $('qty').value = D.packs[S.pack].min; $('qty').min = D.packs[S.pack].min;
  $('mc1Buy').hidden = false;
  var nj = $('noJsBuy'); if (nj) nj.hidden = true;
  renderThumbs();
  render();

  // phone Add to Cart bar: same action as the real button; hidden while that button is on screen
  var bar = $('mSticky');
  if (bar) {
    $('msAdd').addEventListener('click', function () { $('addBtn').click(); });
    var row = $('addBtn').closest('.buy-row');
    var syncBar = function () {
      var r = row.getBoundingClientRect();
      bar.classList.toggle('ms-hide', r.top < window.innerHeight && r.bottom > 0);
    };
    window.addEventListener('scroll', syncBar, { passive: true });
    window.addEventListener('resize', syncBar);
    syncBar();
    document.body.classList.add('has-msticky');
  }
})();

// "i" bubbles (custom logo options, minimum order): click to open, click elsewhere or Esc to close.
// Delegated, because the minimum-order box is redrawn whenever the pack or color changes.
(function () {
  function tipOf(b) { return document.getElementById(b.getAttribute('aria-controls')); }
  function closeAll(except) {
    [].forEach.call(document.querySelectorAll('.hs-info'), function (b) {
      if (b === except) return;
      b.setAttribute('aria-expanded', 'false');
      var t = tipOf(b); if (t) t.hidden = true;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.hs-info');
    if (b) {
      e.preventDefault(); e.stopPropagation();
      var t = tipOf(b), open = t && t.hidden;
      closeAll(b);
      if (t) { t.hidden = !open; b.setAttribute('aria-expanded', open ? 'true' : 'false'); }
      return;
    }
    if (!e.target.closest('.hs-tip')) closeAll();
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
})();
